module.exports = __webpack_public_path__ + "static/media/3.5a21280b.JPG";